import { mapState, mapMutations } from "vuex";

import open_sound from "@/assets/audio/unlock.mp3";
import run_sound from "@/assets/audio/roll.mp3";
import win_sound from "@/assets/audio/battlewin.ogg";
import lose_sound from "@/assets/audio/lose.ogg";

import * as apis from "@/api";
import { CaseOpening, Award } from "@/components/UI";
import CaseOpeningMore from "./components/openMoreCase.vue";
import userImg from "../../assets/images/user/ava_none.jpg";
import OpenMultiplePeopleCaseItem from "./components/OpenMultiplePeopleCase/OpenMultiplePeopleCase";
import LoadingScope from "@/components/UI/LoadingScope/index.vue";
import battleCaseDetail from "./components/battleCaseDetail.vue";
import { conversion } from "@/tool";
import countDown from "@/components/countDown";
import InteractivePanel from "@/components/interactive_panel";
export default {
  data() {
    return {
      /** 箱子信息 */
      mpc_info: {},
      /** 是否跳过开箱动画 */
      is_jump_multiplePeopleCase_open_animation: false,
      /** 音乐 */
      sounds: [],
      /** 开箱个数 */
      case_open_number: 1,
      /** 箱子历史掉落列表 */
      drop_awards: [],
      /** 开箱是否正在运行 */
      isRunning: false,
      /** 出资份额 */
      contributionCount: 1,
      userImg,
      list: [1, 2, 3, 4, 5, 6, 7, , 9, 10],
      //是否开奖
      is_open_multiplePeopleCase: false,
      isShowAward: false,
      //是否自动开奖
      autoMPCCaseOpen: false,
      //开奖结果
      dropAwardDetail: {},
      isLoadingShow: false,
      //mpcCaseSettings: {},
      lastShowPrice: 0,
      lastCreatePrice: 0,
      current_case_drop_index: 0,
      isCaseDetailMoreModal: false,
      caseDetailMoreDetail: {},
      isMainBtnLoading: false,
      isDebounce: false,
      initPageCheckContriCount: false,
      /** 开箱获得奖品列表 */
      case_opened_awards: [],
      isShowPassword: false,
      password: "",
      currentWidth: 0,
      currentMPCTab: 1,
      awardPlayerList: [], //获奖名单
    };
  },
  filters: {
    conversion,
  },
  components: {
    "p-case-opening": CaseOpening,
    "p-case-opening-more": CaseOpeningMore,
    "c-award": Award,
    "c-open-multiple-people-case-item": OpenMultiplePeopleCaseItem,
    "c-loading-scope": LoadingScope,
    "c-battleCaseDetail": battleCaseDetail,
    "c-countDown": countDown,
    "c-interactive-panel": InteractivePanel,
  },
  computed: {
    ...mapState(["user", "config", "isMute" , "mpCaseList"]),
    backIconWidthHeight() {
      return this.$screen.mobile ? "16px" : "21px";
    },
    curUserRealId() {
      return parseInt(this.user.id );
    },
    // 判断当前是否是手机端
    matchPhoneMedia() {
      return window.matchMedia("(max-width: 768px)").matches;
    },
    lastShowPriceRatio() {
      return Math.floor(
        Number((this.lastShowPrice / this.mpc_info.price) * 100)
      );
    },
    //操作按钮校验
    onCheckContributionCountInput() {
      let condition1 =
        Number(this.lastShowPrice) >=
        conversion(
          Number(Number(this.mpc_info.price) - Number(this.mpc_info.currAmount))
        );
      let condition2 =
        Number(Number(this.lastShowPrice) + Number(this.mpc_info.joinPrice)) >=
        Number(
          Number(this.mpc_info.price) *
            Number(this.mpCaseList.mpcCaseSettings.mpCaseMaximumPercent)
        );
      if (condition2) {
        return {
          checkstatus: false,
          error: "已达到当前可合开最大份额",
        };
      }
      if (condition1) {
        return {
          checkstatus: false,
          error: `当前金额大于剩余价格${conversion(
            Number(
              Number(this.mpc_info.price) - Number(this.mpc_info.currAmount)
            )
          )}元`,
        };
      }
      return { checkstatus: true };
    },
  },
  watch: {
    contributionCount(val) {
      this.lastShowPrice = conversion(
        Number(
          this.mpc_info.price * this.mpCaseList.mpcCaseSettings.mpCaseMinimumPercent * val
        )
      );
      this.lastCreatePrice = conversion(
        Number(this.lastShowPrice * this.mpCaseList.mpcCaseSettings.mpCaseOwnerDiscount)
      );
    },
    // 【新增监听】：监听 mpcCaseSettings
    'mpCaseList.mpcCaseSettings': {
      handler(newVal) {
        // 确保 newVal 存在，并且不是空对象，且当前没有处于加载完成后的其他冲突状态中
        if (newVal && Object.keys(newVal).length > 0) {
          console.log("监听到 mpcCaseSettings 加载完成，开始初始化详情...");
          this.init_mpcDetail();
        }
      },
      deep: true,      // 深度监听对象内部属性变化
      immediate: true  // 如果组件挂载时就已经有值了，立即执行一次
    }
  },
  async created() {
    this.isLoadingShow = true;
    this.is_jump_multiplePeopleCase_open_animation =
      sessionStorage.getItem("is_jump_multiplePeopleCase_open_animation") ===
      "true";
    var sounds = {
      open: new Audio(open_sound),
      run: new Audio(run_sound),
      win: new Audio(win_sound),
      lose: new Audio(lose_sound),
    };
    this.sounds = sounds;
    
  },
  async mounted() {

    
    //监听MPCaseFinished 开箱成功通知
    this.onListenMPCaseFinished();
    //在这里获取手机端的当前宽度
    setTimeout(() => {
      this.$nextTick(() => {
        this.currentWidth = window.innerWidth; // 获取当前设备宽度
        // console.log("当前手机宽度为:", this.currentWidth);
      });
    }, 1000);

    await this.init_mpcHub();
  },
  async beforeDestroy() {
    this.$mpCaseHub.onConnected = null;
    this.$mpCaseHub.onReconnected = null;
    this.$mpCaseHub.conn.off("MPCaseFinished");
  },
  methods: {
    ...mapMutations(["setSpinShow", "setloginModal", "setPayModal"]),
    init_mpcHub() {
      /*if (this.$mpCaseHub.conn.state == "Connected") {
        console.log("Connected11");
        
      }

      this.$mpCaseHub.onConnected = () => {
        console.log("Connected22");
        this.init_mpcDetail();
      };

      this.$mpCaseHub.onReconnected = () => {
        console.log("Connected33");
        this.init_mpcDetail();
      };*/
      console.log("Connected11", JSON.stringify(this.mpCaseList.mpcCaseSettings));
      this.init_mpcDetail();
    },
    //监听MPCaseFinished 开箱成功通知
    onListenMPCaseFinished() {
      this.$mpCaseHub.conn.on("MPCaseFinished", async (data) => {
        console.log("监听收到开箱成功通知", data);
        let players = data.players.filter(
          (item) => item.id == this.curUserRealId
        );
        console.log("players==", players);
        if (players.length > 0) {
          this.$toast.success(`合开箱【${data.cases[0].name}】打开中~`);
          setTimeout(() => {
            this.$toast.success(`合开箱【${data.cases[0].name}】已打开~`);
            return;
          }, 15000);
        }
        await this.init_mpcDetail();
        await this.onMPCOpenHandler();
      });
    },
    //初始化箱子详情
    async init_mpcDetail() {
      this.contributionCount = 1;
      this.password = "";
      await this.get_mpc_detail();
      //await this.getMPCaseSettings();
      console.log("this.mpc_info===", this.mpc_info);
      this.lastShowPrice = conversion(
        Number(
          this.mpc_info.price *
            this.mpCaseList.mpcCaseSettings.mpCaseMinimumPercent *
            this.contributionCount
        )
      );
      this.lastCreatePrice = conversion(
        Number(this.lastShowPrice * this.mpCaseList.mpcCaseSettings.mpCaseOwnerDiscount)
      );
      this.initPageCheckContriCount =
        await this.initPageCheckContriCountHandler();
      this.isLoadingShow = false;
      if (
        this.mpc_info.status == 0 &&
        this.mpc_info.joinRatio >=
          Number(this.mpCaseList.mpcCaseSettings.mpCaseMaximumPercent * 100)
      ) {
        this.$toast.error("您已满额 ，请邀朋友参与~");
      }
      console.log(
        "是否是自动开箱this.$route.params.isAutoOpenAward==",
        this.$route.params.isAutoOpenAward
      );
      if (this.$route.params.isAutoOpenAward) {
        //自动开奖
        await this.onMPCOpenHandler();
        this.$route.params.isAutoOpenAward = false;
      }
      await this.get_mpc_drop(this.current_case_drop_index);
      await this.setSpinShow(false);
    },
    //初始化校验当前可操作
    initPageCheckContriCountHandler() {
      let condition1 =
        Number(this.lastShowPrice) >=
        conversion(
          Number(Number(this.mpc_info.price) - Number(this.mpc_info.currAmount))
        );
      let condition2 =
        Number(Number(this.lastShowPrice) + Number(this.mpc_info.joinPrice)) >=
        Number(
          Number(this.mpc_info.price) *
            Number(this.mpCaseList.mpcCaseSettings.mpCaseMaximumPercent)
        );
      if (this.mpc_info.status != 0) {
        return false;
      }
      if (condition2) {
        return false;
      }
      if (condition1) {
        return false;
      }
      return true;
    },
    async get_mpc_detail() {
      let get_mpc_detail_response = await apis.getMPCaseDetail(
        this.$route.params.id
      );
      if (get_mpc_detail_response.data.code !== 0) {
        return;
      }
      this.mpc_info = get_mpc_detail_response.data.data;
      this.mpc_info.joinPrice = 0;
      this.mpc_info.joinRatio = 0;
      let curAmountRatio = `${Math.floor(
        Number((this.mpc_info.currAmount / this.mpc_info.price) * 100)
      )}`;
      this.$set(this.mpc_info, "curAmountRatio", curAmountRatio);
      this.mpc_info.endTime = new Date(this.mpc_info.endTime).getTime();
      if (this.mpc_info.cases && this.mpc_info.cases.length == 1) {
        this.mpc_info["currentCaseName"] = this.mpc_info.cases[0].name;
      } else if (this.mpc_info.cases && this.mpc_info.cases.length > 1) {
        this.mpc_info.cases.sort((a, b) => b.price - a.price);
        this.mpc_info["currentCaseName"] = `${this.mpc_info.cases[0].name}...`;
      }
      this.awardPlayerList = [];
      if (this.mpc_info.players && this.mpc_info.players.length > 0) {
        this.mpc_info.players.forEach((player) => {
          player["ratio"] = `${Math.floor(
            Number((player.amount / this.mpc_info.price) * 100)
          )}`;
          player.avatar = player.avatar
            ? this.$imgfilter(player.avatar)
            : this.userImg;
          if (this.curUserRealId == player.id) {
            this.mpc_info.joinPrice = player.amount;
            this.mpc_info.joinRatio = player.ratio;
          }
          if (player.awardItems && player.awardItems.length > 0) {
            this.awardPlayerList.push(player);
          }
        });
      }
      this.mpc_info.cases.forEach(async (mpc_item) => {
        let totalRate = mpc_item.items
          .map((_) => _.viewRate)
          .reduce((a, b) => a + b, 0);
        await mpc_item.items.forEach((case_awards_item, index) => {
          this.$set(case_awards_item, "itemname", case_awards_item.name);
          this.$set(case_awards_item, "itempic", case_awards_item.picture);
          case_awards_item.viewRate =
            Math.ceil((case_awards_item.viewRate / totalRate) * 10000000) /
            100000;
        });
        this.$set(mpc_item, "drop_awards", []);
        this.$set(mpc_item, "case_awards", mpc_item.items);
      });
    },
    //获取多人开箱箱子开箱记录
    async get_mpc_drop(index) {
      let mpc_item = this.mpc_info.cases[index];
      //获取箱子开箱记录
      const cases_opened_response = await apis.indexHistory({
        caseId: mpc_item.id,
      });
      mpc_item.drop_awards = [];
      cases_opened_response.data.data.list.forEach((item, index) => {
        const foundItem = mpc_item.case_awards.find(
          (_) => _.name == item.item.name
        );
        if (foundItem !== undefined) {
          let obj = {
            ...foundItem,
            itemname: foundItem.name,
            itempic: foundItem.picture,
          };
          mpc_item.drop_awards.push(obj);
        }
      });
    },
    onCheckContributionCountSubmit() {
      let condition1 =
        Number(this.lastShowPrice) >
        conversion(
          Number(Number(this.mpc_info.price) - Number(this.mpc_info.currAmount))
        );
      let condition2 =
        Number(Number(this.lastShowPrice) + Number(this.mpc_info.joinPrice)) >
        Number(
          Number(this.mpc_info.price) *
            Number(this.mpCaseList.mpcCaseSettings.mpCaseMaximumPercent)
        );
      if (
        (this.mpc_info.isPrivate && this.password == "") ||
        this.password == null ||
        this.password == undefined
      ) {
        this.$toast.error("请输入密码");
        return false;
      }
      if (condition2) {
        this.$toast.error("已达到当前可合开最大份额");
        return false;
      }
      if (condition1) {
        this.$toast.error(
          `当前金额大于剩余价格${conversion(
            Number(
              Number(this.mpc_info.price) - Number(this.mpc_info.currAmount)
            )
          )}元`
        );
        return false;
      }
      return true;
    },
    //当箱子状态为0：已创建（合开中）
    onMPContributionHandler() {
      if (!this.user.nickname) return this.$store.commit("setloginModal", true);
      if (this.mpc_info.isPrivate) {
        this.isShowPassword = true;
      } else {
        this.isShowPassword = false;
        this.onMPCJoinHandle();
      }
    },
    async onMPCJoinHandle() {
      if (!this.onCheckContributionCountSubmit()) return;
      if (this.isMainBtnLoading) return;
      this.isMainBtnLoading = true;
      const params = {
        CaseId: this.mpc_info.id,
        PieceCount: this.contributionCount,
        password: this.password,
      };
      if (this.isHappyCoin) params.useHappyCoin = true;
      await this.$mpCaseHub.conn
        .invoke("GCRequestJoinMPCase", params)
        .then((lpMsg) => {
          console.log(lpMsg);
          if (lpMsg.success) {
            this.$toast.success(lpMsg.data);
            this.$store.commit("setInfo");
            this.init_mpcDetail(); //重新刷新一下
            this.isMainBtnLoading = false;
            this.isShowPassword = false;
          } else {
            this.$toast.error(lpMsg.msg);
            this.isMainBtnLoading = false;
          }
        });
    },
    //点击查看开箱事件
    async onMPCOpenHandler() {
      // 未登录处理
      if (!this.user.nickname) {
        this.setloginModal(true);
        return;
      }
      this.autoMPCCaseOpen = true;
      //如果开箱为运行状态则不运行
      if (this.isRunning) return;
      this.isRunning = true; //设置状态
      this.case_opened_awards = [];
      let allawardItemsList = [];
      await this.mpc_info.players.forEach((players_item) => {
        players_item.awardItems.forEach((awardItem) => {
          if (!awardItem.isGarbageAward) {
            let item = {
              caseId: awardItem.caseId,
              groupId: awardItem.groupId,
              itemname: awardItem.name,
              itempic: awardItem.picture,
              name: awardItem.name,
              picture: awardItem.picture,
              mSerial: awardItem.mSerial,
              price: awardItem.price,
              rarity: awardItem.rarity,
              rarityName: awardItem.rarityName,
              isConvert: false,
              converting: false,
              AwardPlayersId: players_item.id,
              awardPlayerName: players_item.name,
            };
            allawardItemsList.push(item);
          }
        });
      });
      await this.mpc_info.cases.forEach((case_item) => {
        //调整奖品顺序
        this.case_opened_awards.push(
          allawardItemsList.filter((_) => {
            return _.caseId == case_item.id;
          })[0]
        );
      });
      await this.$nextTick();
      //开箱开始运行
      if (this.mpc_info.cases.length <= 1) {
        this.$refs.multiplePeopleCase_opening_box.start(
          this.case_opened_awards[0]
        );
      } else {
        this.$refs.mpc_case_opening_box_more.start(this.case_opened_awards);
      }
      this.playStartAudio();
    },
    playStartAudio() {
      if (!this.isMute && !this.is_jump_case_open_animation) {
        this.sounds["open"].currentTime = 0;
        this.sounds["open"].play();
        this.sounds["run"].currentTime = 0;
        this.sounds["run"].playbackRate = 1.8;
        this.sounds["run"].play();
      }
    },
    //单人开箱运动完成
    async on_multiplePeopleCase_opened() {
      this.isRunning = false; //设置开箱运行状态
      if (!this.isMute) {
        this.sounds["win"].currentTime = 0;
        this.sounds["win"].play();
      }
      this.is_open_multiplePeopleCase = true;
      this.isShowAward = true;
    },
    handleContributionCountReduceSelect() {
      if (this.contributionCount <= 1) return;
      this.contributionCount--;
    },
    handleContributionCountAddSelect() {
      if (!this.onCheckContributionCountInput.checkstatus) {
        if (this.onCheckContributionCountInput.error) {
          this.$toast.error(this.onCheckContributionCountInput.error);
        }
        return;
      }
      this.contributionCount++;
    },
    // 最低出资份额校验
    onContributionCountInput(e) {
      this.contributionCount = e.target.value.replace(/[^0-9]/g, "");
    },
    onContributionCountBlur() {
      if (
        this.contributionCount == "" ||
        this.contributionCount <= 1 ||
        !this.onCheckContributionCountInput.checkstatus
      ) {
        this.contributionCount = 1;
      }
    },
    //动画
    toggleMultiplePeopleCaseAnimation() {
      sessionStorage.setItem(
        "is_jump_multiplePeopleCase_open_animation",
        String(this.is_jump_multiplePeopleCase_open_animation)
      );
    },
    swtichCasesDropHandle(index) {
      if (this.current_case_drop_index == index) return;
      this.current_case_drop_index = index;
      this.get_mpc_drop(this.current_case_drop_index);
    },
    async openCaseDetailMoreModal(data) {
      let case_info_response = await apis.api_CaseDetail(data.id);
      if (case_info_response.data.code !== 0) {
        return;
      }
      const respone = case_info_response.data.data;
      let totalRate = respone.items
        .map((_) => _.viewRate)
        .reduce((a, b) => a + b, 0);
      await respone.items.forEach((case_awards_item, index) => {
        case_awards_item.viewRate =
          Math.ceil((case_awards_item.viewRate / totalRate) * 10000000) /
          100000;
      });
      this.caseDetailMoreDetail = respone;
      console.log("this.caseDetailMoreDetail==", this.caseDetailMoreDetail);
      this.isCaseDetailMoreModal = true;
    },
    onCloseRewardHandle() {
      this.autoMPCCaseOpen = false;
      this.get_mpc_detail();
    },
  },
};
